// true when a data field holds a real value (empty, "NA" and missing values are not shown on cards)
function bwHas(v) {
  return v !== undefined && v !== null && String(v).trim() !== '' && !/^(na|n\/a)$/i.test(String(v).trim());
}
window.addEventListener('load', function () {
  const sections = document.querySelectorAll('#loc .container .row.justify-content-center');
  let sectionIndex = 1;
  Object.keys(siteData).forEach((sectionType) => {
    // `stays` is a placeholder category with no row; rows after the last category (Health & Wellness) are static
    if (sectionType !== 'stays' && siteData[sectionType]) {
      // a category with no place keeps its row (rows follow the category order) but the row is hidden
      if (siteData[sectionType].length) initializeSection(sectionType, siteData[sectionType], sectionIndex);
      else if (sections[sectionIndex - 1]) sections[sectionIndex - 1].hidden = true;
      sectionIndex++;
    }
  });
  const aboutSection = document.querySelector('#about');
  if (!aboutSection) {
      return;
  }
  const isStaticLeftColumnPage = document.body.classList.contains('knowmore-page');
  if (isStaticLeftColumnPage) {
    updateLeftColumnContentForKnowMore();
    updateRightColumnOnly();
    return;
  }
  const mainContainer = document.createElement('div');
  mainContainer.className = 'container-fluid';
  mainContainer.style.padding = '2rem';
  const row = document.createElement('div');
  row.className = 'row';
  const leftColumn = document.createElement('div');
  leftColumn.className = 'col-lg-6';
  leftColumn.style.padding = '1rem';
   var  currentPageId = getCurrentPageId();
  var  currentcatId = getCurrentCatagoryId();
  if ( currentcatId !== undefined  && currentcatId  != null &&   currentPageId !== undefined && currentPageId != null
  && currentcatId.length!=0  && currentPageId.length!=0  )
  {
  var currentItem = Object.values(siteData)[currentcatId].filter(item => item.id === eval(currentPageId));
  const imgContainer = document.createElement('div');
  imgContainer.style.marginBottom = '2rem';
  imgContainer.style.position = 'relative';
  imgContainer.style.overflow = 'hidden';
  imgContainer.style.width = '100%';
  imgContainer.style.height = '400px';
  const imgWrapper = document.createElement('div');
  imgWrapper.style.position = 'relative';
  imgWrapper.style.width = '100%';
  imgWrapper.style.height = '100%';
  imgWrapper.style.transition = 'transform 0.5s ease';
  const leftArrow = document.createElement('div');
leftArrow.className = 'image-nav-arrow image-nav-left';
leftArrow.innerHTML = '<i class="fas fa-chevron-left"></i>';
leftArrow.style.position = 'absolute';
leftArrow.style.left = '15px';
leftArrow.style.top = '50%';
leftArrow.style.transform = 'translateY(-50%)';
leftArrow.style.zIndex = '2';
leftArrow.style.cursor = 'pointer';
leftArrow.style.color = 'white';
leftArrow.style.fontSize = '20px';
leftArrow.style.backgroundColor = 'rgba(0,0,0,0.6)';
leftArrow.style.width = '40px';
leftArrow.style.height = '40px';
leftArrow.style.borderRadius = '40px';
leftArrow.style.display = 'none';
leftArrow.style.transition = 'all 0.3s ease';
leftArrow.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
leftArrow.style.alignItems = 'center';
leftArrow.style.justifyContent = 'center';
leftArrow.style.padding = '0';
const rightArrow = document.createElement('div');
rightArrow.className = 'image-nav-arrow image-nav-right';
rightArrow.innerHTML = '<i class="fas fa-chevron-right"></i>';
rightArrow.style.position = 'absolute';
rightArrow.style.right = '15px';
rightArrow.style.top = '50%';
rightArrow.style.transform = 'translateY(-50%)';
rightArrow.style.zIndex = '2';
rightArrow.style.cursor = 'pointer';
rightArrow.style.color = 'white';
rightArrow.style.fontSize = '20px';
rightArrow.style.backgroundColor = 'rgba(0,0,0,0.6)';
rightArrow.style.width = '40px';
rightArrow.style.height = '40px';
rightArrow.style.borderRadius = '50%';
rightArrow.style.display = 'none';
rightArrow.style.transition = 'all 0.3s ease';
rightArrow.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
rightArrow.style.alignItems = 'center';
rightArrow.style.justifyContent = 'center';
rightArrow.style.padding = '0';
leftArrow.addEventListener('mouseenter', () => {
  leftArrow.style.backgroundColor = 'rgba(0,0,0,0.8)';
  leftArrow.style.transform = 'translateY(-50%) scale(1.1)';
});
leftArrow.addEventListener('mouseleave', () => {
  leftArrow.style.backgroundColor = 'rgba(0,0,0,0.6)';
  leftArrow.style.transform = 'translateY(-50%) scale(1)';
});
rightArrow.addEventListener('mouseenter', () => {
  rightArrow.style.backgroundColor = 'rgba(0,0,0,0.8)';
  rightArrow.style.transform = 'translateY(-50%) scale(1.1)';
});
rightArrow.addEventListener('mouseleave', () => {
  rightArrow.style.backgroundColor = 'rgba(0,0,0,0.6)';
  rightArrow.style.transform = 'translateY(-50%) scale(1)';
});
  const currentItemData = currentItem[0];
  const images = currentItemData.image;
  const imageArray = Array.isArray(images) ? images : [images];
  let currentImageIndex = 0;
  imageArray.forEach((src, index) => {
    const img = document.createElement('img');
    img.src = src;
    img.alt = currentItemData.name;
    img.className = 'img-fluid';
    img.width = 800; // the slider box is 400px high: the attributes only reserve the space (no layout shift)
    img.height = 400;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.borderRadius = '10px';
    img.style.position = 'absolute';
    img.style.top = '0';
    img.style.left = `${index * 100}%`;
    img.style.transition = 'transform 0.5s ease';
    img.style.minWidth = '100%';
    imgWrapper.appendChild(img);
  });

  // Set initial transform to show the first image
  imgWrapper.style.transform = 'translateX(0%)';
    if (imageArray.length > 1) {
      leftArrow.style.display = 'flex';
      rightArrow.style.display = 'flex';
    } else {
      leftArrow.style.display = 'none';
      rightArrow.style.display = 'none';
    }
  function updateImage(direction) {
    if (imageArray.length <= 1) return;
    const newIndex = direction === 'next'
      ? (currentImageIndex + 1) % imageArray.length
      : (currentImageIndex - 1 + imageArray.length) % imageArray.length;
    imgWrapper.style.transform = `translateX(-${newIndex * 100}%)`;
    currentImageIndex = newIndex;
  }
  leftArrow.addEventListener('click', () => updateImage('prev'));
  rightArrow.addEventListener('click', () => updateImage('next'));
  imgContainer.appendChild(imgWrapper);
  imgContainer.appendChild(leftArrow);
  imgContainer.appendChild(rightArrow);
  const descContainer = document.createElement('div');
  descContainer.innerHTML = `
      <h3 class="text-white mb-3">${currentItemData.name}</h3>
      <div class="mb-3">
          <a href="#nearby-places" id="nearbyplaces" ><span class="text-warning">View places within 15 Kms from ${currentItemData.name}</span></a> </div>
      <div class="mb-3">
          ${bwHas(currentItemData.rating) ? '<span class="text-warning">★ ' + currentItemData.rating + '</span>' : ''}
          ${bwHas(currentItemData.distance) ? '<span class="text-white-50 ml-2">' + currentItemData.distance + 'km from Kalpetta</span>' : ''}
		  <span class="text-white-50 ml-2">
			<a ${currentItemData.map ? 'href="' + currentItemData.map + '"' : 'hidden'} target="_new" rel="noopener" aria-label="${currentItemData.name} on Google Maps" class="text-decoration-none text-white">
			<i class="fas fa-map-marker-alt" style="color: var(--bw-teal);"></i>
			</a>
		  </span>
 </div>
      <div class="mb-3">
          <small class="text-white-50">
            <ul style="list-style:none;">
            ${bwHas(currentItemData.timing) ? '<li><i class="fas fa-clock"></i> Timing: ' + currentItemData.timing + '<br></li>' : ''}
            ${bwHas(currentItemData.transport) ? '<li><i class="fas fa-car-side"></i> Transportation: ' + currentItemData.transport + '</li>' : ''}
            ${bwHas(currentItemData.seasontovisit) ? '<li><i class="fas fa-cog"></i> Best Seasons to Visit: ' + currentItemData.seasontovisit + '</li>' : ''}
            <li><i class="fas ${bwCatOf(currentcatId).icon}"></i> Type: ${bwCatOf(currentcatId).label || currentItemData.type}</li>
            ${bwHas(currentItemData.holidays) ? '<li><i class="fas fa-power-off"></i> Holiday: ' + currentItemData.holidays + '</li>' : ''}
            ${bwHas(currentItemData.Contact) ? '<li><i class="fas fa-phone"></i> Contact: ' + currentItemData.Contact + '</li>' : ''}
            <li><img title="Black and White Stays Service Villa"  alt="Black and White Stays Wayanad"  width="20" height="20" src="https://www.bwstays.com/assets/img/icons/cloudy.webp"  />Weather: <span id="loctemperature"></span> </li>
            </ul>
        </small>
      </div>
      <div class="mb-3">
                 <span class="text-white-50 ml-2"><p class="content">${currentItemData.description}</p>  <p class="content"></p></span>
       </div>
 `;
$("#nearby-places h2").text("Locations Nearby " + currentItemData.name);
  leftColumn.appendChild(imgContainer);
  leftColumn.appendChild(descContainer);
  const rightColumnHead = document.createElement('div');
  rightColumnHead.className = 'col-lg-7';
  rightColumnHead.style.padding = '1rem';
  rightColumnHead.description = 'places';
  rightColumnHead.className = 'border-bottom border-primary text-center mb-4';
  rightColumnHead.style ='width:100%;margin:0 auto';
  rightColumnHead.innerHTML = `
      <h5 class="text-white"><i class="fas ${bwCatOf(currentcatId).icon} bw-cat-icon" aria-hidden="true"></i> ${bwCatOf(currentcatId).label || currentItemData.type} Places</h5>  `;
  const rightColumn = document.createElement('div');
  rightColumn.className = 'col-lg-6';
  rightColumn.style.padding = '1rem';
    rightColumn.appendChild(rightColumnHead);
  const cardsContainer = document.createElement('div');
  cardsContainer.className = 'row';
  const filteredItems =  Object.values(siteData)[currentcatId].filter(item => item.id !== eval(currentPageId));
  filteredItems.forEach((item, index) => {
      const cardCol = document.createElement('div');
      cardCol.className = 'col-md-6 mb-4';
      const card = document.createElement('div');
      card.className = 'card bg-dark border-light h-100';
      card.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';
      card.addEventListener('mouseleave', function() {
          this.style.transform = 'translateY(0)';
          this.style.boxShadow = 'none';
      });
      const itemImages = Array.isArray(item.image) ? item.image : [item.image];
      const firstImage = itemImages[0];
      card.innerHTML = `
          <div class="card-img-container" style="height: 200px; overflow: hidden; position: relative;">${typeof bwCategoryChip === 'function' ? bwCategoryChip(Object.keys(siteData)[currentcatId]) : ''}
              <img title="Black and White Stays Service Villa" src="${firstImage}" width="400" height="200" loading="lazy" decoding="async" class="card-img-top" alt="${item.name}"
                   style="height: 100%; width: 100%; object-fit: cover; transition: transform 0.3s ease;">
          </div>
          <div class="card-body d-flex flex-column">
              <h5 class="card-title text-white">${item.name}</h5>
              <div class="rating mb-2">
                  ${bwHas(item.rating) ? '<span class="text-warning">★ ' + item.rating + '</span>' : ''}
                  ${bwHas(item.distance) ? '<span class="text-white-50 ml-2 "> <span class="text-warning">' + item.distance + ' km </span> from Kalpetta</span>' : ''}
                    <span class="text-white-50 ml-2"><a ${currentItemData.map ? 'href="' + currentItemData.map + '"' : 'hidden'} target="_new" rel="noopener" aria-label="${currentItemData.name} on Google Maps" class="text-decoration-none text-white">
				  			<i class="fas fa-map-marker-alt" style="color: var(--bw-teal);"></i>
						</a>
						</span>
              </div>
              <p class="card-text text-white-50 flex-grow-1">${item.description.substring(0,100)}...</p>
              <div class="card-footer-info mb-3">
                  <small class="text-white-50">
                      ${bwHas(item.timing) ? '<i class="fas fa-clock"></i> ' + item.timing + '<br>' : ''}
                      ${bwHas(item.transport) ? '<i class="fas fa-car-side"></i> ' + item.transport + ' <br>' : ''}
					            ${bwHas(item.holidays) ? '<i class="fas fa-calendar-week"></i> ' + item.holidays + ' <br>' : ''}
                      ${bwHas(item.Contact) ? '<i class="fas fa-phone"></i> ' + item.Contact : ''}
                  </small>
              </div>
              <a  id="attractions"  href="${item.knowmore}"${/^https:\/\/www\.bwstays\.com\//.test(item.knowmore || '') ? '' : ' target="_blank" rel="noopener noreferrer"'} class="btn btn-primary btn-sm mt-auto">Attractions</a>
          </div>
      `;
      cardCol.appendChild(card);
      cardsContainer.appendChild(cardCol);
  });
  rightColumn.appendChild(cardsContainer);
  row.appendChild(leftColumn);
  row.appendChild(rightColumn);
  mainContainer.appendChild(row);
  aboutSection.innerHTML = '';
  aboutSection.appendChild(mainContainer);
  }
});
function updateRightColumnOnly() {
  var currentPageId = getCurrentPageId();
  var currentcatId = getCurrentCatagoryId();
  const rightColumnContainer = document.querySelector('#plantation-places');
  if (!rightColumnContainer) {
    return;
  }
  rightColumnContainer.innerHTML = '';
  const filteredItems = Object.values(siteData)[currentcatId].filter(item => item.id !== eval(currentPageId));
  filteredItems.forEach((item) => {
    const cardCol = document.createElement('div');
    cardCol.className = 'col-md-6 mb-4';
    const card = document.createElement('div');
    card.className = 'card bg-dark border-light h-100';
    card.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';
    card.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = 'none';
    });
    const itemImages = Array.isArray(item.image) ? item.image : [item.image];
    const firstImage = itemImages[0];
    card.innerHTML = `
      <div class="card-img-container" style="height: 200px; overflow: hidden; position: relative;">${typeof bwCategoryChip === 'function' ? bwCategoryChip(Object.keys(siteData)[currentcatId]) : ''}
        <img title="${item.name}" loading="lazy" decoding="async" src="${firstImage}" width="400" height="200" class="card-img-top" alt="${item.name}"
             style="height: 100%; width: 100%; object-fit: cover; transition: transform 0.3s ease;">
      </div>
      <div class="card-body d-flex flex-column">
        <h5 class="card-title text-white">${item.name}</h5>
        <div class="rating mb-2">
          ${bwHas(item.rating) ? '<span class="text-warning">★ ' + item.rating + '</span>' : ''}
          ${bwHas(item.distance) ? '<span class="text-white-50 ml-2">' + item.distance + 'km from Kalpetta</span>' : ''}
          <span class="text-white-50 ml-2">
            <a ${item.map ? 'href="' + item.map + '"' : 'hidden'} target="_new" rel="noopener" aria-label="${item.name} on Google Maps" class="text-decoration-none text-white">
              <i class="fas fa-map-marker-alt" style="color: var(--bw-teal);"></i>
            </a>
          </span>
        </div>
        <p class="card-text text-white-50 flex-grow-1">${item.description.substring(0,100)}...</p>
        <div class="card-footer-info mb-3">
          <small class="text-white-50">
            ${bwHas(item.timing) ? '<i class="fas fa-clock"></i> ' + item.timing + '<br>' : ''}
            ${bwHas(item.transport) ? '<i class="fas fa-car-side"></i> ' + item.transport + ' <br>' : ''}
            ${bwHas(item.holidays) ? '<i class="fas fa-calendar-week"></i> ' + item.holidays + ' <br>' : ''}
            ${bwHas(item.Contact) ? '<i class="fas fa-phone"></i> ' + item.Contact : ''}
          </small>
        </div>
        <a href="${item.knowmore}"${/^https:\/\/www\.bwstays\.com\//.test(item.knowmore || '') ? '' : ' target="_blank" rel="noopener noreferrer"'} class="btn btn-primary btn-sm mt-auto" rel="dofollow" title="Know more about ${item.name}" data-i18n="nav.km">Know More</a>
      </div>
    `;
    cardCol.appendChild(card);
    rightColumnContainer.appendChild(cardCol);
  });
  const nearbyPlacesTitle = document.querySelector('#nearby-places h2');
  if (nearbyPlacesTitle) {
    const currentItem = Object.values(siteData)[currentcatId].find(item => item.id === eval(currentPageId));
    if (currentItem) {
      nearbyPlacesTitle.textContent = "Locations Nearby " + currentItem.name;
    }
  }
}

function updateLeftColumnContentForKnowMore() {
  var currentPageId = getCurrentPageId();
  var currentcatId = getCurrentCatagoryId();

  const leftColumnContainer = document.querySelector('#left-content-column .det-marg-f');
  if (!leftColumnContainer) {
    return;
  }

  // Clear existing content
  leftColumnContainer.innerHTML = '';

  // Get current item data
  const currentItem = Object.values(siteData)[currentcatId].filter(item => item.id === eval(currentPageId));
  if (!currentItem || currentItem.length === 0) {
    return;
  }

  const currentItemData = currentItem[0];
  const images = currentItemData.image;
  const imageArray = Array.isArray(images) ? images : [images];

  // Create image container
  const imgContainer = document.createElement('div');
  imgContainer.style.marginBottom = '2rem';
  imgContainer.style.position = 'relative';
  imgContainer.style.overflow = 'hidden';
  imgContainer.style.width = '100%';
  imgContainer.style.height = '400px';

  const imgWrapper = document.createElement('div');
  imgWrapper.style.position = 'relative';
  imgWrapper.style.width = '100%';
  imgWrapper.style.height = '100%';
  imgWrapper.style.transition = 'transform 0.5s ease';

  // Create images
  let currentImageIndex = 0;
  imageArray.forEach((src, index) => {
    const img = document.createElement('img');
    img.src = src;
    img.alt = currentItemData.name;
    img.className = 'img-fluid';
    img.width = 800; // the slider box is 400px high: the attributes only reserve the space (no layout shift)
    img.height = 400;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.borderRadius = '10px';
    img.style.position = 'absolute';
    img.style.top = '0';
    img.style.left = `${index * 100}%`;
    img.style.transition = 'transform 0.5s ease';
    img.style.minWidth = '100%';
    imgWrapper.appendChild(img);
  });

  // Set initial transform to show the first image
  imgWrapper.style.transform = 'translateX(0%)';

  // Get existing arrows
  const leftArrow = document.querySelector('.image-nav-arrow.image-nav-left');
  const rightArrow = document.querySelector('.image-nav-arrow.image-nav-right');

  // Show/hide arrows based on image count
  if (imageArray.length > 1) {
    if (leftArrow) leftArrow.style.display = 'flex';
    if (rightArrow) rightArrow.style.display = 'flex';
  } else {
    if (leftArrow) leftArrow.style.display = 'none';
    if (rightArrow) rightArrow.style.display = 'none';
  }

  // Image navigation function
  function updateImage(direction) {
    if (imageArray.length <= 1) return;
    const newIndex = direction === 'next'
      ? (currentImageIndex + 1) % imageArray.length
      : (currentImageIndex - 1 + imageArray.length) % imageArray.length;
    imgWrapper.style.transform = `translateX(-${newIndex * 100}%)`;
    currentImageIndex = newIndex;
  }

  // Add event listeners to arrows if they exist
  if (leftArrow) {
    // Remove any existing event listeners to avoid duplicates
    const newLeftArrow = leftArrow.cloneNode(true);
    leftArrow.parentNode.replaceChild(newLeftArrow, leftArrow);
    newLeftArrow.addEventListener('click', () => updateImage('prev'));
  }

  if (rightArrow) {
    // Remove any existing event listeners to avoid duplicates
    const newRightArrow = rightArrow.cloneNode(true);
    rightArrow.parentNode.replaceChild(newRightArrow, rightArrow);
    newRightArrow.addEventListener('click', () => updateImage('next'));
  }

  // Append image wrapper to container
  imgContainer.appendChild(imgWrapper);

  // Add the carousel to the left column
  leftColumnContainer.appendChild(imgContainer);
}

// the shared label and icon (data/categories.js) of the category at this index of siteData
function bwCatOf(catIndex) {
  const key = Object.keys(siteData)[catIndex];
  return (typeof bwCategories !== 'undefined' && bwCategories[key]) || { icon: 'fa-map-marker-alt', label: '' };
}

function initializeSection(sectionType, data, sectionIndex) {
  let sectionContainer;
  let sectionTitle;
  const allSections = document.querySelectorAll('#loc .container .row.justify-content-center');
  const isOdd = sectionIndex % 2 === 1;
  if (sectionIndex - 1 < allSections.length) {
    sectionContainer = allSections[sectionIndex - 1];
    const titleElement = sectionContainer.querySelector('.project-text h3, .project-text h4');
    if (titleElement) {
      sectionTitle = titleElement.textContent;
    } else {
      sectionTitle = sectionType === 'trucking' ? 'Trekking' : sectionType.charAt(0).toUpperCase() + sectionType.slice(1);
    }
  } else {
    return;
  }
  if (!sectionContainer) {
    return;
  }
  const imgColumn = sectionContainer.querySelector('.col-lg-6 img');
  if (!imgColumn) {
    return;
  }
  const imgColumnParent = imgColumn.closest('.col-lg-6');
  const contentColumn = sectionContainer.querySelector('.col-lg-6:not(:has(img))');
  const isImageOnRight = imgColumnParent.nextElementSibling === null || !imgColumnParent.nextElementSibling.classList.contains('col-lg-6');
  const imgElement = imgColumn;
  const arrowContainer = document.createElement('div');
  arrowContainer.className = 'arrows-container';
  sectionContainer.appendChild(arrowContainer);
  const leftArrow = document.createElement('div');
  leftArrow.className = 'tab-arrow tab-arrow-left';
  leftArrow.innerHTML = '&laquo;';
  leftArrow.setAttribute('aria-label', 'Previous tab');
  arrowContainer.appendChild(leftArrow);
  const rightArrow = document.createElement('div');
  rightArrow.className = 'tab-arrow tab-arrow-right';
  rightArrow.innerHTML = '&raquo;';
  rightArrow.setAttribute('aria-label', 'Next tab');
  arrowContainer.appendChild(rightArrow);
  let currentTabIndex = 0;
  leftArrow.addEventListener('click', function () {
    currentTabIndex = (currentTabIndex > 0) ? currentTabIndex - 1 : data.length - 1;
    updateContent('prev', isOdd);
  });
  rightArrow.addEventListener('click', function () {
    currentTabIndex = (currentTabIndex < data.length - 1) ? currentTabIndex + 1 : 0;
    updateContent('next', isOdd);
  });
  const textContainer = sectionContainer.querySelector('.project-text');
  if (!textContainer) {
    return;
  }
  textContainer.innerHTML = '';
  const titleElement = document.createElement('h3');
  titleElement.className = 'h4 text-white';
  // the label and icon of the type of place: data/categories.js, the same on every page
  const cat = typeof bwCategories !== 'undefined' ? bwCategories[sectionType] : null;
  if (cat) {
    const ic = document.createElement('i');
    ic.className = 'fas ' + cat.icon + ' bw-cat-icon';
    ic.setAttribute('aria-hidden', 'true');
    titleElement.appendChild(ic);
    titleElement.appendChild(document.createTextNode(' ' + cat.label));
  } else {
    titleElement.textContent = sectionTitle;
  }
  //alert(sectionIndex);
  //titleElement.setAttribute('data-i18n','disc.item'+sectionIndex);

  textContainer.appendChild(titleElement);
  const line = document.createElement('div');
  line.className = 'border-bottom border-primary text-center mb-4';
  line.style ='width:100%;margin:0 auto';
  textContainer.appendChild(line);
  const tabContent = document.createElement('div');
  tabContent.className = 'tab-content';
  textContainer.appendChild(tabContent);
  const hr = document.createElement('hr');
  hr.className = 'd-none d-lg-block mb-0 ' + (isImageOnRight ? 'ml-0' : 'mr-0');
  const imgWrapper = document.createElement('div');
  imgWrapper.className = 'img-wrapper';
  imgWrapper.style.position = 'relative';
  imgWrapper.style.overflow = 'hidden';
  imgWrapper.style.width = '100%';
  imgWrapper.style.height = '100%';
  imgElement.parentNode.insertBefore(imgWrapper, imgElement);
  imgWrapper.appendChild(imgElement);
  // the picture is shown whole; its own blurred copy fills the rest of the frame (see css #loc .img-wrapper)
  imgWrapper.style.backgroundImage = 'url("' + imgElement.src + '")';


  function updateContent(direction = 'next', isHorizontal = true) {
    const currentItem = data[currentTabIndex];
    const tempImg = document.createElement('img');
    tempImg.className = 'temp-image';
    tempImg.src = Array.isArray(currentItem.image) ? currentItem.image[0] : currentItem.image;
    tempImg.alt = currentItem.name;
    tempImg.style.position = 'absolute';
    tempImg.style.top = '0';
    tempImg.style.left = '0';
    tempImg.style.width = '100%';
    tempImg.style.height = '100%';
    tempImg.style.opacity = '0';
    if (isHorizontal) {
      tempImg.style.left = direction === 'next' ? '-100%' : '100%';
      tempImg.style.top = '0';
    } else {
      tempImg.style.top = direction === 'next' ? '-100%' : '100%';
      tempImg.style.left = '0';
    }
    imgWrapper.appendChild(tempImg);
    imgWrapper.style.backgroundImage = 'url("' + tempImg.src + '")';
    const oldImages = imgWrapper.querySelectorAll('img:not(.temp-image)');
    oldImages.forEach(oldImg => {
      oldImg.style.transition = 'all 0.5s ease';
      oldImg.style.opacity = '0';
      if (isHorizontal) {
        oldImg.style.left = direction === 'next' ? '100%' : '-100%';
      } else {
        oldImg.style.top = direction === 'next' ? '100%' : '-100%';
      }
      setTimeout(() => {
        oldImg.remove();
      }, 500);
    });
    const tempContent = document.createElement('div');
    tempContent.className = 'tab-content-temp';
    tempContent.innerHTML = `
      <h4 class="text-white mb-1" style="font-size: 1rem;">${currentItem.name}${bwHas(currentItem.rating) ? ' (' + currentItem.rating + '★)' : ''}</h4>
      <p class="mb-1 text-white-50" style="font-size: 0.8rem; line-height: 1.2;">${currentItem.description.substring(0,50)}...</p>
      <div class="mb-1 text-white-50" style="font-size: 0.8rem;">
        ${bwHas(currentItem.holidays) ? '<i class="fas fa-times me-1" style="color: var(--bw-teal);"></i> Holiday: ' + currentItem.holidays : ''}
      </div>
      <div class="mb-1 text-white-50" style="font-size: 0.8rem; ">
        ${bwHas(currentItem.timing) ? '<i class="fas fa-clock me-1" style="color: var(--bw-teal);"></i> Timing: ' + currentItem.timing : ''}
      </div>
      <a href="${currentItem.knowmore || '#'}" class="js-scroll-trigger view-attraction" style="font-size: 0.8rem;">View Attractions</a>`;
    tempContent.style.position = 'absolute';
    tempContent.style.width = '100%';
    tempContent.style.opacity = '0';
    tempContent.style.height = 'auto';
    tempContent.style.maxHeight = 'none';
    tempContent.style.overflow = 'visible';
    tempContent.style.padding = '0';
    tempContent.style.margin = '0';
    tempContent.style.display = 'flex';
    tempContent.style.flexDirection = 'column';
    if (isHorizontal) {
      tempContent.style.left = direction === 'next' ? '-50px' : '50px';
    } else {
      tempContent.style.top = direction === 'next' ? '-50px' : '50px';
    }
    tabContent.appendChild(tempContent);
    const oldContents = tabContent.querySelectorAll('.tab-content-temp:not(:last-child)');
    oldContents.forEach(oldContent => {
      oldContent.style.transition = 'all 0.5s ease';
      oldContent.style.opacity = '0';
      if (isHorizontal) {
        oldContent.style.left = direction === 'next' ? '50px' : '-50px';
      } else {
        oldContent.style.top = direction === 'next' ? '50px' : '-50px';
      }
      setTimeout(() => {
        oldContent.remove();
      }, 500);
    });
    setTimeout(() => {
      tempImg.style.transition = 'all 0.5s ease';
      tempImg.style.opacity = '1';
      if (isHorizontal) {
        tempImg.style.left = '0';
      } else {
        tempImg.style.top = '0';
      }
      setTimeout(() => {
        tempImg.classList.remove('temp-image');
      }, 500);
    }, 50);
    setTimeout(() => {
      tempContent.style.transition = 'all 0.5s ease';
      tempContent.style.opacity = '1';
      if (isHorizontal) {
        tempContent.style.left = '0';
      } else {
        tempContent.style.top = '0';
      }
    }, 50);
  }
  updateContent('next', isOdd);
}